import React, { useState } from "react";
import Logo from "../assets/kayrex.jpg";
import { HashLink } from "react-router-hash-link";
import {
  BsFacebook,
  BsInstagram,
  BsLinkedin,
  BsTiktok,
  BsTwitter,
} from "react-icons/bs";
import { MdEmail, MdSupportAgent } from "react-icons/md";
import { TbSocial } from "react-icons/tb";
import { FiMenu, FiX } from "react-icons/fi";

const Header = () => {
  const [showSocial, showSocialChanged] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="header-main">
      {/* Logo */}
     <HashLink to="/"> <img alt="Kayrex" src={Logo} className="header-logo" /></HashLink>

      {/* Navbar */}
      <nav className="header-navbar">
        <div
          className="hamburger-menu"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <FiX /> : <FiMenu />}
        </div>
        <ul className={`nav-links ${isMenuOpen ? "show" : ""}`}>
          <li>
          <HashLink to="/aboutus" className="header-nav-link">
          About
            </HashLink>
          </li>
          <li>
            <HashLink to="/#courses" className="header-nav-link">
              Courses
            </HashLink>
          </li>
          <li>
            <HashLink to="/#contactus" className="header-nav-link">
              Contact
            </HashLink>
          </li>
        </ul>
      </nav>

      {/* Socials */}
      <div className="d-flex align-items-center gap-3">
        <div className="header-icons mobile-visible">
          <div onClick={() => showSocialChanged(!showSocial)}>
            <TbSocial />
          </div>
          {showSocial ? (
            <div className="header-overlay">
              <a
                href="https://www.facebook.com/profile.php?id=100094205407984"
                target="_blank"
                rel="noreferrer"
              >
                <BsFacebook className="header-icons" />
              </a>
              <br />
              <a
                href="https://www.instagram.com/kayrexacademy_/"

                target="_blank"
                rel="noreferrer"
              >
                <BsInstagram className="header-icons" />
              </a>
              <br />
              <a
                href="https://www.tiktok.com/@kayrex_academy?is_from_webapp=1&sender_device=pc"
                target="_blank"
                rel="noreferrer"
              >
                <BsTiktok className="header-icons" />
              </a>
              <br />
              <a
                href="https://x.com/kayrexacademy?s=11&t=6ie5kieNQlXKyB3DP1-wLg"
                target="_blank"
                rel="noreferrer"
              >
                <BsTwitter className="header-icons" />
              </a>
              <br />
              <a
                href="mailto:info@kayrexacademy.com"
                target="_blank"
                rel="noreferrer"
              >
                <MdEmail className="header-icons" />
              </a>
              <br />
            </div>
          ) : null}
        </div>
        <BsFacebook
          className="header-icons mobile-invisible"
          onClick={() =>
            window.open(
              "https://web.facebook.com/people/Kayrex/100094205407984/"
            )
          }
        />
        <BsInstagram
          className="header-icons mobile-invisible"
          onClick={() =>
            window.open(
              "https://www.instagram.com/kayrexacademy_/"
            )
          }
        />
        <BsTiktok
          className="header-icons mobile-invisible"
          onClick={() =>
            window.open(
              "https://www.tiktok.com/@kayrexacademy?_t=8oSvXbY6e1o&_r=1"
            )
          }
        />
        <BsTwitter
          className="header-icons mobile-invisible"
          onClick={() =>
            window.open(
              "https://x.com/kayrexacademy?s=11&t=6ie5kieNQlXKyB3DP1-wLg"
            )
          }
        />
        <a
          href="mailto:info@kayrexacademy.com"
          target="_blank"
          rel="noreferrer"
        >
          <MdEmail className="header-icons mobile-invisible" />
        </a>
        <a
          className="header-button"
          href="https://wa.me/+353899435322?text=Hello, Kayrex Academy. I will like to enquire about your bootcamps"
          target="_blank"
          rel="noreferrer"
        >
          <MdSupportAgent></MdSupportAgent> Live Chat
        </a>
      </div>
    </div>
  );
};

export default Header;
